import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const AssessmentNavigation = ({ completedModules = [] }) => {
  const location = useLocation();

  const assessmentModules = [
    { 
      id: 'supplier', 
      label: 'Manajemen Pemasok', 
      path: '/supplier-management',
      icon: 'Users'
    },
    { 
      id: 'operational', 
      label: 'Penilaian Operasional', 
      path: '/operational-assessment',
      icon: 'Settings'
    },
    { 
      id: 'equipment', 
      label: 'Analisis Peralatan', 
      path: '/equipment-analysis',
      icon: 'Wrench'
    },
    { 
      id: 'financial', 
      label: 'Analisis Keuangan', 
      path: '/financial-analysis-form',
      icon: 'DollarSign'
    },
    { 
      id: 'market', 
      label: 'Penilaian Pasar', 
      path: '/market-assessment',
      icon: 'TrendingUp'
    },
    { 
      id: 'governance', 
      label: 'Evaluasi Tata Kelola', 
      path: '/governance-evaluation',
      icon: 'Shield'
    },
  ];

  const isActive = (path) => location?.pathname === path;
  const isCompleted = (moduleId) => completedModules?.includes(moduleId);

  return (
    <div className="assessment-nav">
      <div className="assessment-nav-content">
        <div className="assessment-nav-tabs">
          {assessmentModules?.map((module) => (
            <Link
              key={module.id}
              to={module.path}
              className={`assessment-nav-tab ${isActive(module.path) ? 'active' : ''} ${isCompleted(module.id) ? 'completed' : ''}`}
            >
              <div className="flex items-center gap-2">
                <Icon name={module.icon} size={18} />
                <span>{module.label}</span>
                {isCompleted(module.id) && (
                  <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AssessmentNavigation;